import React, {ChangeEvent, forwardRef} from "react";
import VolumeButton from "./VolumeButton/VolumeButton";
import TimeDisplayTitle from "./TimeDisplayTitle/TimeDisplayTitle";
import FullScreenButton from "./FullScreenButton/FullScreenButton";
import PlatbackRateButton from "./PlatbackRateButton/PlatbackRateButton";
import {Box, Slider} from "@mui/material";
import {PlayPauseButtonMain} from "./PlayPauseButtonMain/PlayPauseButtonMain";
import {PlayPauseButton} from "./PlayPauseButton/PlayPauseButton";
import ExtendedButton from "./ExtendedButton/ExtendedButton";
import SettingsButton from "./SettingsButton/SettingsButton";
import FastForwardButton from "./FastForwardButton/FastForwardButton";
import FastRewindButton from "./FastRewindButton/FastRewindButton";



interface ControlsProps {
	onPlayPause: () => void;
	onRewind: () => void;
	onFastForward: () => void;
	onPlaybackRateChange: (rate: number) => void;
	playbackRate: number;
	playing: boolean;
	onChangeDispayFormat: () => void;
	elapsedTime: string;
	totalDuration: string;
	onMute: () => void;
	muted: boolean;
	volume: number;
	onVolumeChange: (event: ChangeEvent<HTMLInputElement>) => void;
	played: number;
	onSeek: (e: any) => void;
	onSeekMouseDown: (event: any) => void;
	onSeekMouseUp: (event: any) => void;
	duration: number;
	toggleFullScreen: () => void;
	timeDisplayFormat: string;
	collapsed: any;
	setCollapsed: (collapsed: boolean) => void;
}


// eslint-disable-next-line react/display-name
const Controls = forwardRef<HTMLDivElement, ControlsProps>(({
																onPlayPause,
																playing,
																onRewind,
																onFastForward,
																duration,
																toggleFullScreen,
																onPlaybackRateChange,
																playbackRate,
																onChangeDispayFormat,
																elapsedTime,
																totalDuration,
																onMute,
																muted,
																volume,
																onVolumeChange,
																played,
																onSeek,
																timeDisplayFormat,
																collapsed,
                                								setCollapsed
															}, ref) => {

	return (
		<Box
			ref={ref}
			style={{
				visibility: "visible",
				position: "absolute",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}
		>

			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<PlayPauseButtonMain onPlayPause={onPlayPause} playing={playing}/>
				<Box
					sx={{
						position: "absolute",
						background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #011224 100%)',
						width: "100%",
						bottom: 1,
					}}
				>
					<Box
						sx={{
							padding: "0 24px",
						}}
					>
						<Slider
							min={0}
							max={duration}
							step={1}
							value={played * duration}
							onChange={(_, value) => onSeek(value)}
							valueLabelDisplay="auto"
							aria-labelledby="input-slider"
							sx={{
								'& .MuiSlider-thumb': {
									display: 'none',
								},
								'& .MuiSlider-rail': {
									height: '8px',
								},
							}}
						/>

					</Box>
					{/* ЛЕВАЯ ЧАСТЬ*/}
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							alignItems: "center",
							justifyContent: "space-between",
							padding: "0 24px 24px 24px",
						}}
					>
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
								justifyContent: "space-between",
							}}
						>
							<PlayPauseButton onPlayPause={onPlayPause} playing={playing} />

							<Box sx={{
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
								justifyContent: "space-between",
								gap: '4px',
								margin: "0 12px",
							}}>
								<FastRewindButton onRewind={onRewind} />
								<PlatbackRateButton onPlaybackRateChange={onPlaybackRateChange} playbackRate={playbackRate} />
								<FastForwardButton onFastForward={onFastForward} />
							</Box>
							<TimeDisplayTitle timeDisplayFormat={timeDisplayFormat} onChangeDispayFormat={onChangeDispayFormat} elapsedTime={elapsedTime} totalDuration={totalDuration} />
						</Box>

						{/* ПРАВАЯ ЧАСТЬ*/}
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
								gap: '12px',
								justifyContent: "space-between",
							}}
						>
							<VolumeButton
								onMute={onMute}
								muted={muted}
								volume={volume}
								onVolumeChange={onVolumeChange}
							/>
							<SettingsButton/>
							<ExtendedButton
								collapsed={collapsed}
								setCollapsed={setCollapsed}
							/>
							<FullScreenButton onToggleFullScreen={toggleFullScreen} />
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
});

export default Controls;
